<template>
    <section>
        <base-card>
        <h2> Page not found!</h2>
        <p>Unfortunately, it seems the page you are searching for doesnt exist. Maybe go back to our <router-link to="/coaches">Coaches page</router-link>?</p>
    </base-card>
    </section>
</template>

<style scoped>
    a{
        text-decoration:none;
        color:black;
    }
    a:hover{
        color:green;
        text-decoration:bold;
    }
</style>